import styled from 'styled-components';
import {DialogHeaderDefaultBox} from './dialog-header.default.box';

export const DialogHeaderCipBox = styled(DialogHeaderDefaultBox)`
    position: relative;

    &::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 1px;
        background: linear-gradient(90deg, transparent, white, transparent);
    }
`;